import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const FormatsVuexModule = {
  namespaced: true,
  state: () => ({
    $_moduleApiPath: "v1.0/UserAccessLimits",
    $_paramApiPath: "v1.0/Audit",
    $_currentLimit: {},
    $_errorState: {},
    $_actionState: {
      message: "",
      status: 200,
      data: {}
    }
  }),
  getters: {
    currentLimit: (state) => state.$_currentLimit,
    actionState: (state) => state.$_actionState,
    errorState: (state) => state.$_errorState
  },
  actions: {
    initLimit({ commit }, returnData) {
      var userLimit = {
        userId: "",
        userName: "",
        isAgent: false,
        isCoordinator: false,
        isExcluded: false,
        localCode: "",
        branchOffices: [],
        businessUnits: [],
        macroLines: [],
        lines: []
      };

      if (returnData) return userLimit;
      else commit("SET_LIMIT", userLimit);
    },
    setLimit({ commit }, format) {
      commit("SET_LIMIT", format);
    },
    async getLimit({ commit, dispatch, state, rootGetters }, userId) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + userId;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_LIMIT", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async getTableData(
      { commit, dispatch, state, rootGetters },
      { schema, name }
    ) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink =
        baseUrl +
        state.$_paramApiPath +
        "/GetAuditableTableData/" +
        schema +
        "/" +
        name;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        var response = await axios.get(actionLink, axiosConfig);
        return response.data || {};
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async createLimit({ commit, dispatch, state, rootGetters }, limit) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        limit.id = 0;
        const response = await axios.post(actionLink, limit, axiosConfig);
        limit.id = response.data.id;
        commit("SET_LIMIT", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async updateLimit({ commit, dispatch, state, rootGetters }, data) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + data.userId;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.put(actionLink, data, axiosConfig);

        commit("SET_LIMIT", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    }
  },
  mutations: {
    SET_LIMIT(state, value) {
      state.$_currentLimit = value;
    },
    SET_ERROR(state, value) {
      state.$_errorState = value;
    }
  }
};

export default FormatsVuexModule;
